import { OPEN_MEDIA_DRAWER, CLOSE_MEDIA_DRAWER } from 'modules/chat/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   open: boolean,
 *   contextId: string | null,
 * }} MediaDrawerState
 */

/** @type {MediaDrawerState} */
const initialState = {
  open: false,
  contextId: null,
};

export default createReducer(initialState, {
  [OPEN_MEDIA_DRAWER]: (_state, { payload }) => ({
    open: true,
    contextId: payload.contextId,
  }),
  [CLOSE_MEDIA_DRAWER]: () => initialState,
});
